import React, {useEffect, useRef, useState, memo} from 'react';
import CloseIconComponent from "../../reusable/CloseIconComponent";
import TimePicker from '../../timePicker/TimePicker';
import Calendar from 'react-calendar';
import './style.scss';
import ApplyButtons from "../../reusable/ApplyButtons";
import useClickOutside from "../../../hooks/useClickOutside";

interface Props {
    applyHandler: (newDate: Date) => void,
    cancelHandler: () => void,
    time: any,
}

const CalendarComponent: React.FC<Props> = ({applyHandler, time, cancelHandler}) => {
    const [dateLoc, setDateLoc] = useState<null | string>(null);
    const [timeLoc, setTimeLoc] = useState<null | string>(null);
    const [fullTime, setFullTime] = useState<null | Date>(null);
    const ref = useRef<HTMLDivElement | null>(null);

    useClickOutside(ref, cancelHandler);

    const setUpTime = (name: string, value: number) => {
        if (!fullTime) return;
        const newTime:any = new Date(fullTime.valueOf());
        switch(name) {
            case 'year': newTime.setFullYear(value);break;
            case 'month': newTime.setMonth(value);break;
            case 'day': newTime.setDate(value);break;
            case 'hour12': newTime.setHours(value);break;
            case 'hour24': newTime.setHours(value);break;
            case 'hour': newTime.setHours(value);break;
            case 'minute': newTime.setMinutes(value);break;
            case 'second': newTime.setSeconds(value);break;
            default: {}
        }
        setFullTime(new Date(newTime.valueOf()));
    };

    const onChangeByTypingTime = (time: string) => {
        setFullTime(new Date(dateLoc + ' ' + time));
    };

    const onChangeDate = (d: any) => {
        setFullTime(new Date(d.toDateString() + ' ' + timeLoc));
    };

    const applyNewTime = () => {
        if (fullTime) applyHandler(fullTime);
    };

    useEffect(() => {
        setFullTime(time);
    }, [time]);

    useEffect(() => {
        if (fullTime) {
            setDateLoc(fullTime.toDateString());
            setTimeLoc(fullTime.toTimeString());
        }
    }, [fullTime]);

    if (!fullTime) return null;

    return (
            <div className='calendar-wrapper'
                 ref={ref}
            >
                <div className='calendar-title' >Date/time picker
                    <CloseIconComponent handler={applyNewTime} />
                </div>
                <div className='calendar-container'>
                    <Calendar
                        activeStartDate={new Date(fullTime)}
                        value={new Date(fullTime)}
                        maxDate={new Date()}
                        minDate={new Date(0)}
                        onChange={onChangeDate}
                        className={'react-calendar'}
                        tileClassName={'calendar__tile'}
                        minDetail={'month'}
                    />

                    <div className='w-100 flex js-c time-picker'

                    >
                        <TimePicker
                            onChange={onChangeByTypingTime}
                            value={new Date(fullTime)}
                            maxDetail={'second'}
                            calendarIcon={null}
                            clearIcon={null}
                            className={'date-picker'}
                            disableClock={true}
                            disableCalendar={true}
                            increaseValue={setUpTime}
                            decreaseValue={setUpTime}
                            // locale={'sv-sv'}  // uses for demonstrating 24 hours
                            arrows={['hour24', 'hour12', 'minute', 'second']}
                        />
                    </div>
                    <div>
                        <ApplyButtons
                            disable={false}
                            cancelHandler={cancelHandler}
                            OKHandler={applyNewTime}
                        />
                    </div>

                </div>
        </div>
    )
};

const areEqual = (prevProps: any, nextProps: any) => {
    return prevProps.time.getTime() === nextProps.time.getTime();
}

export default memo(CalendarComponent, areEqual);